import { useQuery } from '@tanstack/react-query';
import API_ENDPOINTS from '../../../services/urls';
import axiosInstance from '../../../ns_libs/nsAxios';
import { OrganizationSubproject } from '../types';

interface IParams {
    orgId: string;
    enabled?: boolean;
}

const getUserSubprojects = async (orgId: string) => {
    const response = await axiosInstance.get<OrganizationSubproject[]>(API_ENDPOINTS.ORGANIZATION_USER_SUBPROJECTS(orgId));
    return response.data;
};

const useUserSubprojects = ({ orgId, enabled = true }: IParams) => useQuery({
    queryKey: ['userSubprojects', orgId],
    queryFn: () => getUserSubprojects(orgId),
    enabled,
});

export default useUserSubprojects;
